import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuVoteHeader } from '../../../widgets/menu-vote-header';
import { MenuVoteHero } from '../../../widgets/menu-vote-hero';
import { MenuCarousel } from '../../../features/menu-carousel';
import { VoteCta } from '../../../features/vote-cta';
import { RestaurantInfo } from '../../../entities/restaurant-info';
import {
  HERO_COPY,
  INITIAL_ACTIVE_INDEX,
  MENU_ITEMS,
  RESTAURANT,
  VOTE_SELECTED_MENU_STORAGE_KEY,
} from '../../../shared/config/menuVoteData';
import {
  Carousel,
  CtaWrap,
  Footer,
  Foreground,
  Restaurant,
  RewardNotice,
} from './MenuVotePage.styles';

const PAGE_TITLE = '사람들이 제일 많이 고른 메뉴 맞추기';
const PAGE_DESCRIPTION =
  '가장 주문하고 싶은 따뜻한 메뉴에 투표하세요. 가장 인기 있는 메뉴를 맞추면 리워드를 드립니다!';
const OG_IMAGE = `${process.env.PUBLIC_URL ?? ''}/twitter_card.jpg`;

/** 문서 <head> 메타 설정 (CRA에 react-helmet 미도입 → 직접 주입) */
function useDocumentMeta() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const upsertMeta = (selector: string, attr: 'name' | 'property', key: string, content: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    upsertMeta('meta[name="description"]', 'name', 'description', PAGE_DESCRIPTION);
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', PAGE_TITLE);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', PAGE_DESCRIPTION);
    upsertMeta('meta[property="og:image"]', 'property', 'og:image', OG_IMAGE);
    document.documentElement.lang = 'ko';
  }, []);
}

/**
 * 메뉴 투표 페이지 (page)
 * widgets/features/entities 를 조립만 한다.
 * 출처: _workspace/01_design-analyst_spec.md
 */
export function MenuVotePage() {
  useDocumentMeta();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(INITIAL_ACTIVE_INDEX);

  return (
    <>
      <MenuVoteHeader />
      {/* 콘텐츠 */}
      <Foreground>
        <MenuVoteHero />
        
        <Restaurant aria-label="식당 정보">
          <RestaurantInfo
            name={RESTAURANT.name}
            type={RESTAURANT.type}
            logo={RESTAURANT.logo}
            logoSize={RESTAURANT.logoSize}
          />
        </Restaurant>

        <Carousel aria-label="메뉴 선택">
          <MenuCarousel
            items={MENU_ITEMS}
            initialIndex={INITIAL_ACTIVE_INDEX}
            onActiveChange={setActiveIndex}
          />
        </Carousel>
      </Foreground>

      <Footer>
          <RewardNotice>
            {HERO_COPY.rewardNotice.map((line, i) => (
              <React.Fragment key={line}>
                {line}
                {i < HERO_COPY.rewardNotice.length - 1 && <br />}
              </React.Fragment>
            ))}
          </RewardNotice>
          <CtaWrap>
            <VoteCta
              onClick={() => {
                const selectedMenu = MENU_ITEMS[activeIndex];
                sessionStorage.setItem('menu-vote-animate-ranking', '1');
                sessionStorage.setItem(VOTE_SELECTED_MENU_STORAGE_KEY, selectedMenu.id);
                navigate('/result', { state: { animateRanking: true, selectedMenu } });
              }}
            />
          </CtaWrap>
      </Footer>

    </>
  );
}
